import styled from 'styled-components';

export const TooltipContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export const TooltipTrigger = styled.div`
  cursor: pointer;
`;

export const TooltipContent = styled.div`
  position: fixed; /* Muda de 'absolute' para 'fixed' para que funcione bem no body */
  top: 0; /* Estes valores serão atualizados dinamicamente */
  left: 0;
  background-color: #d9d9d9;
  color: #333;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 240px;
  width: 100%;
  z-index: 99999999;
  transform: translate(-50%, -130%);
`;

export const TooltipArrow = styled.div`
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #d9d9d9;
`;

export const TooltipText = styled.span`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  display: inline-block;
  color: #3d3d3d;
`;
